export default {
  save: "save",
  "N/A": "N/A",
};
